<template>
  <div :id="id" class="rowcard">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RowCard',
  meta: {
    description: 'Componente padre del RowCardItem',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    id: {
      type: String,
      required: true,
      meta: {
        description: 'Id contenedor para los RowCard',
        example: 'idRowCard',
      },
    },
  },
};
</script>
<style scoped></style>
